var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('iframe',{staticClass:"iframe_rrss",attrs:{"title":"Report Section","src":"https://app.powerbi.com/view?r=eyJrIjoiOTU0YjAzZGMtZTc1OS00ZjUyLWJlODMtN2JlOGExYjg0YWNiIiwidCI6IjY1NzlmZDU2LTM1NTUtNDkwOS1iMTJmLTk4YmNjMWZmN2NmMCIsImMiOjR9","frameborder":"0","allowFullScreen":"true"}})])
}]

export { render, staticRenderFns }